import React from "react";
import { Accordion, Card, Col, Row, Button } from "react-bootstrap";
import { countries } from "../../../../../../resources/countries.json";
import { Input } from "../../../../../library/input";
import { Select } from "../../../../../library/select";
import { Label } from "../../../../../library/label";

const Index = ({ singleContact, setSingleContact }) => {
  const renderCountries = () => {
    const items = [
      {
        id: 0,
        value: "",
        title: "Velg",
        selected: true,
        disabled: false,
      },
    ];
    countries.map((country, index) => {
      items.push({
        id: index + 1,
        value: country.code,
        title: country.title,
        selected:
          singleContact.address &&
          singleContact.address.country === country.code
            ? true
            : false,
        disabled: false,
      });
    });
    return items;
  };

  return (
    <div className="contact-details-container">
      <Accordion className="person-accordion" defaultActiveKey="0">
        <Card className="single-card top">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="0"
            >
              Persondetaljer <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Fornavn
                  </Label>
                  <Input
                    value={
                      singleContact.general && singleContact.general.firstName
                        ? singleContact.general.firstName
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        general: {
                          ...singleContact.general,
                          firstName: e.target.value,
                        },
                      })
                    }
                    placeholder="Fornavn"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Etternavn
                  </Label>
                  <Input
                    value={
                      singleContact.general && singleContact.general.lastName
                        ? singleContact.general.lastName
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        general: {
                          ...singleContact.general,
                          lastName: e.target.value,
                        },
                      })
                    }
                    placeholder="Etternavn"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="1"
            >
              Kontaktpunkter <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    E-postadresse
                  </Label>
                  <Input
                    value={
                      singleContact.contact && singleContact.contact.lastName
                        ? singleContact.contact.lastName
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        contact: {
                          ...singleContact.contact,
                          email: e.target.value,
                        },
                      })
                    }
                    placeholder="E-postadresse"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Telefon
                  </Label>
                  <Input
                    international={true}
                    countryCallingCodeEditable={false}
                    format="phone"
                    value={String(singleContact.contact.phone)}
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        contact: {
                          ...singleContact.contact,
                          phone: e,
                        },
                      })
                    }
                    placeholder="Telefon"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Hjemmeside
                  </Label>
                  <Input
                    value={
                      singleContact.contact && singleContact.contact.website
                        ? singleContact.contact.website
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        contact: {
                          ...singleContact.contact,
                          website: e.target.value,
                        },
                      })
                    }
                    placeholder="Hjemmeside"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="2"
            >
              Bedrift <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Navn
                  </Label>
                  <Input
                    value={
                      singleContact.company && singleContact.company.name
                        ? singleContact.company.name
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        company: {
                          ...singleContact.company,
                          name: e.target.value,
                        },
                      })
                    }
                    placeholder="Navn"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Stilling
                  </Label>
                  <Input
                    value={
                      singleContact.company && singleContact.company.position
                        ? singleContact.company.position
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        company: {
                          ...singleContact.company,
                          position: e.target.value,
                        },
                      })
                    }
                    placeholder="Stilling"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="3"
            >
              Sosiale medier <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Facebook
                  </Label>
                  <Input
                    value={
                      singleContact.social && singleContact.social.facebook
                        ? singleContact.social.facebook
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        social: {
                          ...singleContact.social,
                          facebook: e.target.value,
                        },
                      })
                    }
                    placeholder="Facebook"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Twitter
                  </Label>
                  <Input
                    value={
                      singleContact.social && singleContact.social.twitter
                        ? singleContact.social.twitter
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        social: {
                          ...singleContact.social,
                          twitter: e.target.value,
                        },
                      })
                    }
                    placeholder="Twitter"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="4"
            >
              Addresse <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="4">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Gate
                  </Label>
                  <Input
                    value={
                      singleContact.address && singleContact.address.street
                        ? singleContact.address.street
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        address: {
                          ...singleContact.address,
                          street: e.target.value,
                        },
                      })
                    }
                    placeholder="Gate"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Postnummer
                  </Label>
                  <Input
                    format="postal"
                    value={
                      singleContact.address && singleContact.address.postalCode
                        ? singleContact.address.postalCode
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        address: {
                          ...singleContact.address,
                          postalCode: e.target.value,
                        },
                      })
                    }
                    placeholder="Postnummer"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Poststed
                  </Label>
                  <Input
                    value={
                      singleContact.address && singleContact.address.city
                        ? singleContact.address.city
                        : null
                    }
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        address: {
                          ...singleContact.address,
                          city: e.target.value,
                        },
                      })
                    }
                    placeholder="Poststed"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Land
                  </Label>
                  <Select
                    onChange={(e) =>
                      setSingleContact({
                        ...singleContact,
                        address: {
                          ...singleContact.address,
                          country: e.target.value,
                        },
                      })
                    }
                    items={renderCountries()}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Index;
